/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { NamespaceIamRoleAuthorizationKey } from './namespaceIamRoleAuthorizationKey';


export interface NamespaceIamRoleAuthorization { 
    /**
     * A system unique ID of this user namespace authorization
     */
    id?: number;
    namespaceIamRoleAuthorizationKey?: NamespaceIamRoleAuthorizationKey;
    /**
     * A description of the IAM role
     */
    iamRoleDescription?: string;
}
